import React from 'react';
import styles from './popUp.module.scss';
import '../../constants/_global.scss';
import { ReactComponent as XIcon } from '../../assets/x.svg';
import Button from '../../UI/button/buttonComponent';
import { BUTTON_TYPE, BUTTON_VER } from '../../UI/button/buttonTypes';
import { PopUpDeleteInterface } from './popUpTypes';

const popUpDelete: React.FC<PopUpDeleteInterface> = ({
  onAccept,
  onCancel,
  onClose,
}) => {
  const handleAccept = () => {
    onAccept();
    console.log('Submit');
  };

  const handleCancel = () => {
    console.log('No account click');
    onCancel();
  };

  return (
    <div className={styles.shell}>
      <div className={styles.titleRow}>
        <h1 className="h1">Вы уверены, что хотите удалить объявление?</h1>
        <button type="button" className={styles.XBtn} onClick={onClose}>
          <XIcon />
        </button>
      </div>
      <div className={styles.buttonRow}>
        <Button
          ver={BUTTON_VER.primary}
          type={BUTTON_TYPE.Submit}
          customWidth={127}
          text="Удалить"
          onClick={handleAccept}
        />
        <Button
          ver={BUTTON_VER.secondary}
          type={BUTTON_TYPE.Button}
          text="Отмена"
          customWidth={124}
          onClick={handleCancel}
        />
      </div>
    </div>
  );
};

export default popUpDelete;
